<template>
<a href="#" 
  class="btn-normal" 
  :data-type="color" 
  :class-type="classType"
  @click.prevent="clickButton" 
>
  <slot></slot>
</a>        
</template>

<script>
export default {
  props: {
    text: String,
    color: {
      type: String,
      default(){
        return 'normal'
      }
    } , 
    classType : {
      type : String , 
      default () {
        return 'normal' ; // border-blue
      } 
    }
    
  },
  data () {
    return {
      
    }
  },
  methods: {
    clickButton(event) {
      this.$emit('click' , event );
    }
  }
}
</script>

<style lang="scss">
  .btn-normal {
    display: inline-flex; align-items: center; justify-content: center;
    box-sizing: border-box;
    min-height: 33px;
    padding: 10px 5px;
    border-radius: 4px;;
    font-size: 14px; color: #333;
    background-color: #eee;

    &[data-type='blue'] {
      background-color: $dark-blue;
      color: #fff;
    }

    &[class-type='border-blue-plus'] {
      background-color: $white; 
      font-size: 14px;
      border: 1px solid #1A4EDF; 
      color: #1A4EDF; 
      padding: 8px 16px 8px 10px; 
      @include text-prt-b; 
      text-decoration: none;
      gap: calc( var( --default-gap ) / 2 ); 
      display: inline-flex; 
      width: fit-content; 
      border-radius: calc( var( --default-gap ) / 2 ); 

      &::before {
        display: flex; 
        content: ''; 
        background-repeat: no-repeat; 
        background-position: center center; 
        // background-color: red; 
        background-image: url('@/assets/icons/add.svg'); 
        width: var( --default-gap ); height: var( --default-gap ); 
      }
    }
  }
</style>
